import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const featureContent = [
    {
        title: 'IT 운영·관리 체계 구축',
        desc: '복잡한 운영 환경을 표준화하고 서비스 안정성을 높이는 엔터프라이즈 IT 운영 체계를 설계합니다.',
        routerPath: '/services',
        image: '/assets/img/services/service_image_1.png',
        chips: ['운영 안정화', '통합 관리'],
        tone: 'blue',
        size: 'large',
        dataAos:'fade-up',
        dataDelay:''
    }, {
        title: '데이터 추적 및 보안 고도화',
        desc: '수집-분석-보안 정책을 하나의 흐름으로 연결해 리스크를 낮추고 의사결정을 빠르게 만듭니다.',
        routerPath: '/cyber-security',
        image: '/assets/img/services/service_image_2.png',
        chips: ['관제', '컴플라이언스'],
        tone: 'orange',
        size: 'large',
        dataAos:'fade-up',
        dataDelay:'50'
    }, {
        title: '웹사이트·플랫폼 고도화',
        desc: '브랜드 경험과 전환율을 동시에 높이는 기업형 웹사이트 및 서비스 플랫폼을 구축합니다.',
        routerPath: '/services',
        image: '/assets/img/services/service_image_3.png',
        chips: ['웹 구축', '플랫폼'],
        tone: 'yellow',
        size: 'small',
        dataAos:'fade-up',
        dataDelay:'100'
    }, {
        title: 'AI 업무 자동화 솔루션',
        desc: '반복 업무를 자동화하고 데이터 기반 운영 체계를 만들 수 있도록 AI 적용 범위를 빠르게 확장합니다.',
        routerPath: '/software-development',
        image: '/assets/img/services/service_image_4.png',
        chips: ['자동화', '업무 혁신'],
        tone: 'pink',
        size: 'small',
        dataAos:'fade-up',
        dataDelay:'150'
    }, {
        title: 'UI/UX 디자인 서비스',
        desc: '사용자 여정 중심의 인터페이스 설계로 고객 경험과 서비스 사용성을 함께 개선합니다.',
        routerPath: '/codam-design#design-product',
        image: '/assets/img/services/service_image_5.png',
        chips: ['웹/앱 UX', '서비스 디자인'],
        tone: 'navy',
        size: 'small',
        dataAos:'fade-up',
        dataDelay:'200'
    }
]

const FeatureOne = () => {
    return (
        <Fragment>
            {featureContent.map((val, i) => (
                <div
                    key={i}
                    className={val.size === 'large' ? 'col-lg-6 col-md-12' : 'col-lg-4 col-md-6'}
                    data-aos={val.dataAos}
                    data-aos-delay={val.dataDelay}
                >
                    <div className={`codam-service-box codam-service-box--${val.tone} mb-30`}>
                        <div className="codam-service-box__image-wrap" aria-hidden="true">
                            <img className="codam-service-box__image" src={val.image} alt="" />
                        </div>
                        <div className="codam-service-box__body">
                            <h3 className="codam-service-box__title">
                                <Link to={val.routerPath}>{val.title}</Link>
                            </h3>
                            <p className="codam-service-box__desc">{val.desc}</p>
                        </div>
                        <div className="codam-service-box__footer">
                            <Link className="codam-service-box__arrow" to={val.routerPath} aria-label={`${val.title} 자세히 보기`}>
                                <i className="bi bi-arrow-up-right"/>
                            </Link>
                            <div className="codam-service-box__chips">
                                {val.chips.map((chip) => (
                                    <span key={chip} className="codam-service-box__chip">{chip}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Fragment>
    )
}

export default FeatureOne
